import React, { useState } from 'react';
import uuid from 'uuid-random';
import { useTranslation } from 'react-i18next';
import { sendCustomTrackingInfo } from '@panel/commons';
import DropDown from '@panel/commons/lib/DropDown';
import {
  Container,
  DropDownAcordion,
  DropDownOption,
  HeaderContainter,
  Title,
  Chevron,
  Ask,
  Answer,
  LineBottom
} from './styles';
import { asksAndAnswers } from '../../../helpers/DataFAQS/getDataFAQs';

const FAQs = ({ device }) => {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { [Object.keys(asksAndAnswers).pop()]: lastAsk } = asksAndAnswers;

  return (
    <Container device={device} data-panel='landingZD-faqs-container'>
      <Title device={device} data-panel='landingZD-faqs-title'>
        {t('panel.landing_ZD.faqs.title')}
      </Title>
      <DropDownAcordion device={device} data-panel='landingZD-faqs-dropDownContainer'>
        {asksAndAnswers?.map(askAndAnswer => (
          <DropDownOption key={uuid()}>
            <DropDown
              isOpen={dropdownOpen === askAndAnswer.ask}
              setIsOpen={() => setDropdownOpen(dropdownOpen === askAndAnswer.ask ? null : askAndAnswer.ask)}
              title={askAndAnswer.ask}
              height={300}
              headerComponent={React.createElement(
                'div',
                {},
                <HeaderComponent title={t(askAndAnswer.ask)} isOpen={dropdownOpen === askAndAnswer.ask} />
              )}
              dataPanel={`landingZD-faqs-dropDownAsk-${askAndAnswer.ask}`}
            >
              <Answer device={device} data-panel={`landingZD-faqs-dropDownAnswer-${askAndAnswer.ask}`}>
                {askAndAnswer.answer.map(ans => {
                  if (ans.type === 'bold') {
                    return <b key={ans.key}>{t(ans.key)}</b>;
                  }
                  if (ans.type === 'line-break') {
                    return (
                      <>
                        <br key={ans.key} />
                        {t(ans.key)}
                      </>
                    );
                  }
                  return t(ans.key);
                })}
              </Answer>
            </DropDown>
            {lastAsk.ask !== askAndAnswer.ask && (
              <LineBottom
                isOpen={dropdownOpen === askAndAnswer.ask}
                data-panel={`landingZD-faqs-dropDownLineBottom-${askAndAnswer.ask}`}
              />
            )}
          </DropDownOption>
        ))}
      </DropDownAcordion>
    </Container>
  );
};

const handleOnclick = (title, isOpen) => {
  if (!isOpen)
    sendCustomTrackingInfo({
      event: 'select_content',
      content_type: 'Preguntas frecuentes',
      item_id: title
    });
};
const HeaderComponent = ({ title, isOpen, device }) => {
  return (
    <HeaderContainter onClick={() => handleOnclick(title, isOpen)}>
      <Ask device={device} data-panel={`landingZD-faqs-dropDown-title-${title}`}>
        {title}
      </Ask>
      <Chevron isOpen={isOpen} data-panel={`landingZD-faqs-dropDown-footerChevron-${title}`} />
    </HeaderContainter>
  );
};

export default FAQs;
